exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#advanced-search[data-v-24107bf9] {\n  max-height: calc(100vh - 116px);\n  overflow: auto;\n}\n", ""]);

